import React, { Component } from 'react';
import LoaderMask from '../../components/common/LoaderMask';
import LoggedInPage from '../../views/core/LoggedInPage';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import Loader from 'react-loader-spinner';
import HmAjax from '../../util/HmAjax';
import InfoDetail from './InfoDetail';

import WebQuestionPanel from '../../components/question/WebQuestionPanel';
import Pagination from 'react-ultimate-pagination-material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AbstractQuestionPanel from '../../components/question/AbstractQuestionPanel';
import $ from 'jquery';


$.fn.inView = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $("#questionsParent").scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
	

export default class ViewSolutionLayout extends LoggedInPage{
	constructor(props){
		super(props)
		this.state={
			dataLoaded:false,
			testModalView: "", 
			testModalShow: true, 
			testModalContent: "loading",
			currentScrollIndex: 1
		}

		this.infoData = null;

		this.questionData=[]; 
		this.data = null;
		this.testId = 0;
		this.questions = [];

		this.scoreCalculated = false;
		
		this.questionTypeCount = 0;
		this.questionCount = 0;
		this.attemptCount = 0;
		this.unAttemptedCount = 0;
		this.partialCorrect = 0;
		this.questionsCorrect = 0;
		this.questionsIncorrect = 0;
		this.totalScore = 0;
		this.userScore = 0;
		this.testMode = 1;

		this.renderQuestions = this.renderQuestions.bind(this);
		this.renderQuestionInfo = this.renderQuestionInfo.bind(this);
		this.viewSolnModal = this.viewSolnModal.bind(this);
		this.hideTestModal = this.hideTestModal.bind(this);
		this.setModalClass = this.setModalClass.bind(this);
		this.setModalBackdropClose = this.setModalBackdropClose.bind(this);

		this.onPageChange = this.onPageChange.bind(this);
		//this.scrollFinished = this.scrollFinished.bind(this);
		this.isScrollPreset = false;
	}

	componentDidMount(){
		
		var me = this;
		var scrollTimer = -1;
		$("#questionsParent").scroll(function(event) {
			if(me.isScrollPreset == false){
				var element = document.getElementById("qindex-"+me.state.currentScrollIndex);
				if(me.state.currentScrollIndex != 0 && $(element).inView() == false){
					me.setState({currentScrollIndex:0});
				}			
			}
			
			if (scrollTimer != -1)
				clearTimeout(scrollTimer);
					
			scrollTimer = setTimeout(function(){        	
				me.isScrollPreset = false;
			}, 500);        
		});	

		this.loadQuestionData();
		console.log("ViewSolutionLayout")
	}

	onPageChange(page){
		//console.log(page);
	  	this.isScrollPreset = true;
		this.setState({currentScrollIndex:page});
		var element = document.getElementById("qindex-"+page);
		element.scrollIntoView({behavior: 'smooth', block: "start"});
  	}

	loadQuestionData(){
		let me = this;
		let success = (resp) => {
			me.data = resp;
			me.infoData = resp;
			console.log("resp lalala ::", resp);

			//Setting questionData
			this.questionData = (resp && resp.transcripts && resp.transcripts.length > 0 ) ? resp.transcripts : [];

			me.calculateQuestionCount();

			me.setState({dataLoaded:true});
		}

		let failure = (err) => {

		}

		let url = this.getUrlFor("DIAG_SOLNS_BY_TOPIC");
		url = url.replace("{classId}",this.props.classId).replace("{accessId}",this.props.accessId).replace("{skillId}",this.props.topicId);

		new HmAjax(url).get(success, failure);
	}


	calculateQuestionCount() {
		if (!this.scoreCalculated) {
			this.testMode = (this.data.testDetails && this.data.testDetails.mode) ? this.data.testDetails.mode : 1;
			if (this.testMode === 1) {
				this.calculateScoreForTest();
			} else if (this.testMode === 2) {
				this.calculateScoreForStandard();
			} else if (this.testMode === 3) {
				this.calculateScoreForAdaptive();
			}

			this.scoreCalculated = true;
		}
		
	}

	calculateScoreForTest() {
		var me = this;
		try {
			this.data.transcripts.map((transcript, index) => {
				try {
					me.questionTypeCount++;
					if (transcript.attempts === null || transcript.attempts.length <= 0) {
						me.unAttemptedCount++;
						me.questionCount++;
					} else {
						transcript.attempts.map((attempt, index) => {
							//Push additional details to attempt object 
							attempt.questionNo = transcript.questionNo;
							attempt.testMode = "TEST";

							//This method pushes the question to renderer array
							me.populateQuestions(attempt);

							me.totalScore += attempt.marks;

							me.questionCount++;
							if (attempt.attempted) {
								me.attemptCount++;
								if (attempt.attemptCorrect) {
									me.questionsCorrect++;
								} else if (attempt.partialCorrect) {
									me.partialCorrect++;
								} else {
									me.questionsIncorrect++;
								}
							} else {
								me.unAttemptedCount++;
							}

							me.userScore += attempt.userMarks;
						})
					}
					// For Test, take the user marks
					//me.userScore = me.data.testDetails.marks;
				} catch (e) {
					console.log("Error occurred for the question of index:" + index, e);
				}

			})

		} catch (e) {
			console.error("Error occurred while calculating questions count in Scorecard:", e);
		}
	}

	calculateScoreForAdaptive() {
		var me = this;
		try {
			this.data.transcripts.map((transcript, index) => {
				try {
					me.questionTypeCount++;
					me.questionCount++;
					if (transcript.attempts === null || transcript.attempts.length <= 0) {
						me.unAttemptedCount++;
					} else {
						me.totalScore++;

						if (transcript.answerCorrect) {
							me.userScore++;
							me.questionsCorrect++;
						} else {
							me.questionsIncorrect++;
						}

						transcript.attempts.map((attempt, index) => {
							//Push additional details to attempt object 
							attempt.questionNo = transcript.questionNo;
							attempt.testMode = "PRACTICE";

							//This method pushes the question to renderer array
							me.populateQuestions(attempt);
						})
					}
				} catch (e) {
					console.log("Error occurred for the question of index:" + index, e);
				}

			})

		} catch (e) {
			console.error("Error occurred while calculating questions count in Scorecard:", e);
		}
	}

	calculateScoreForStandard() {
		var me = this;
		try {
			this.data.transcripts.map((transcript, index) => {
				try {
					me.questionTypeCount++;
					if (transcript.attempts === null || transcript.attempts.length <= 0) {
						me.unAttemptedCount++;
					} else {
						transcript.attempts.map((attempt, index) => {
							//Push additional details to attempt object 
							attempt.questionNo = transcript.questionNo;
							attempt.testMode = "TEST";

							//This method pushes the question to renderer array
							me.populateQuestions(attempt);

							me.totalScore++;
							if (attempt.attemptCorrect) {
								me.userScore++;
							}

							me.questionCount++;
							if (attempt.attempted) {
								me.attemptCount++;
								if (attempt.attemptCorrect) {
									me.questionsCorrect++;
								} else if (attempt.partialCorrect) {
									me.partialCorrect++;
								} else {
									me.questionsIncorrect++;
								}
							} else {
								me.unAttemptedCount++;
							}
						})
					}
				} catch (e) {
					console.log("Error occurred for the question of index:" + index, e);
				}

			})

		} catch (e) {
			console.error("Error occurred while calculating questions count in Scorecard:", e);
		}
	}

	populateQuestions(questionAttempt) {
		try {
			this.questions.push(questionAttempt);
		} catch (e) {
			console.log("Error Occurred while populating questions.", e);
		}
	}

	dismiss(){
		if(typeof this.props.unMount === "function"){
			this.props.unMount();
		}
		this.setState({testModalShow:false});
	}

	viewSolnModal(data){
		this.setState({ testModalShow: true, testModalContent: "new loading", modalTitle: "Diagnostic-Detail report", testModalView: "loading", modalLabel:"" });
	}

	hideTestModal() {
		this.dismiss();
		/*this.setState({ testModalShow: false, testModalContent: "loading", modalTitle: "", testModalView: "loading", modalLabel:"" });*/
	}

	setModalClass() {
		if (this.state.testModalView == "testView") {
			return " modal-lg custom-modal";
		} else if (this.state.testModalView == "testInfo") {
			return " modal-lg info-modal";
		} else if (this.state.testModalView == "staticContent") {
			return " modal-lg solution-modal";
		}
		return " modal-lg";
	}
	
	setModalBackdropClose() {
		if (this.state.testModalView == "testView") {
			return "";
		} else if (this.state.testModalView == "testInfo") {
			return "";
		} else if (this.state.testModalView == "staticContent") {
			return this.hideTestModal;
		}
		return this.hideTestModal;
	}
	
	loadModalContent() {
		if (!this.state.dataLoaded) {
			return (
				<div className="text-center loadingAnim">
				<Loader
				type="Oval"
				color="#00BFFF"
				height="100"
				width="100"
				/>
				</div>
				)
			} else {
				return (
				<div>
				
				{this.renderQuestions()}
				</div>
				)
			}
		}


		renderQuestions(){
			var me = this;
			return(
				<MuiThemeProvider>
				<div>
				<div id="questionsParent">
				{this.renderQuestionInfo()}
					{
						(()=>{
							if(this.questions && this.questions.length>0){
								return ( this.questions.map(function (eachques, index) {
									console.log(" eachques :::" , eachques);

									return (
									<div key={index} id={"qindex-"+eachques.questionNo}><AbstractQuestionPanel qno={eachques.questionNo} qdata={eachques} />
									</div>)
								}) )
							}else{
								return(
									<div className="text-center loadingAnim viewsoln_loadingAnim">
									{this.rb("view.solution.noques")}
									</div>
								)
							}
						})()
					}
			
					</div>
				
					{
						(()=>{
							if(this.questionTypeCount && this.questionTypeCount > 0){
								return (
									<div className="col-12 text-center paginationParent">
						<Pagination
						currentPage={this.state.currentScrollIndex}
						totalPages={this.questionTypeCount}
						boundaryPagesRange={5}
						siblingPagesRange={5}
						hidePreviousAndNextPageLinks={true}
						hideFirstAndLastPageLinks={true}
						hideEllipsis={true}
						onChange={this.onPageChange}
					/>
				</div>
								)
							}
						})()
					}
					</div>
				
				

			</MuiThemeProvider> )
				
		}	

		renderQuestionInfo(){
			if(this.infoData){
				this.infoData["topicName"] = this.props.topicName || "";

				return(
				<div>
				<InfoDetail data={this.infoData} />
				</div>
				)	
			}


		}

		render(){
			return(
			<div>
			<TestTakingModalComponent visible={this.state.testModalShow} dialogClassName={this.setModalClass()} onClickBackdrop={this.setModalBackdropClose()}>
			<div className="modal-header bg-purple">
			<div className="modal-title">{this.rb("viewsolution.layout.headermsg")}
			{this.state.modalTitle}
			</div>
			<div className="close" onClick={this.hideTestModal} aria-label="Close" data-ga=''>
			<span aria-hidden="true"><i className="material-icons">close</i></span>
			</div>
			</div>
			<div className="modal-body testModalBody">
			{this.loadModalContent()}
			</div>
			</TestTakingModalComponent>
			</div>
			)
		}
	}


// WEBPACK FOOTER //
// ./src/vendors/mindstretcher/ViewSolutionLayout.js